var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666667 2.00002C1.03486 2.00002 1.33333 1.70154 1.33333 1.33335C1.33333 0.965164 1.03486 0.666687 0.666667 0.666687C0.298477 0.666687 0 0.965164 0 1.33335C0 1.70154 0.298477 2.00002 0.666667 2.00002Z",
    fill: "#597796"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 2.00002C11.7016 2.00002 12.0001 1.70154 12.0001 1.33335C12.0001 0.965164 11.7016 0.666687 11.3334 0.666687H3.33339C2.9652 0.666687 2.66672 0.965164 2.66672 1.33335C2.66672 1.70154 2.9652 2.00002 3.33339 2.00002L11.3334 2.00002Z",
    fill: "#597796"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 6.66669C11.7016 6.66669 12.0001 6.36821 12.0001 6.00002C12.0001 5.63183 11.7016 5.33335 11.3334 5.33335H3.33339C2.9652 5.33335 2.66672 5.63183 2.66672 6.00002C2.66672 6.36821 2.9652 6.66669 3.33339 6.66669H11.3334Z",
    fill: "#597796"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 10.6667C12.0001 11.0349 11.7016 11.3334 11.3334 11.3334H3.33339C2.9652 11.3334 2.66672 11.0349 2.66672 10.6667C2.66672 10.2985 2.9652 10 3.33339 10H11.3334C11.7016 10 12.0001 10.2985 12.0001 10.6667Z",
    fill: "#597796"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 6.00002C1.33333 6.36821 1.03486 6.66669 0.666667 6.66669C0.298477 6.66669 0 6.36821 0 6.00002C0 5.63183 0.298477 5.33335 0.666667 5.33335C1.03486 5.33335 1.33333 5.63183 1.33333 6.00002Z",
    fill: "#597796"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.666667 11.3334C1.03486 11.3334 1.33333 11.0349 1.33333 10.6667C1.33333 10.2985 1.03486 10 0.666667 10C0.298477 10 0 10.2985 0 10.6667C0 11.0349 0.298477 11.3334 0.666667 11.3334Z",
    fill: "#597796"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/List.0d72ee2f3f680efc446b6ae8bd5e38f4.svg";
export { ForwardRef as ReactComponent };